import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';

export default class MetaTelBox {
  constructor() {
    this.$metaNavElement = $('#header-secondary-outer .nectar-center-text a');
    this.$body = $('body');

    this.date = null;
    if (window.metaTelBox) {
      this.data = JSON.parse(window.metaTelBox);
    }
    this.content = '';
  }

  init() {
    const self = this;
    if (!this.data) {
      return;
    }

    $.ajax('/wp-json/facta/v1/get-time')
      .done((data) => {
        self.date = new Date(data);

        if ((self.date.getHours() >= 8 && self.date.getHours() < 17)
          && !(self.date.getDay() === 0 || self.date.getDay() === 6)) {
          self.content = self.data.metaTelBoxContentOffice;
        } else {
          self.content = self.data.metaTelBoxContent;
        }
      })
      .always(() => {
        // mobile/desktop
        if (window.innerWidth <= 690) {
          self.overlay();
        } else {
          self.tooltip();
        }
      })
      .fail(() => {
        console.log('date time get failed'); // eslint-disable-line no-console
      });
  }

  // add overlay button to header and toggle overlay when clicked.
  overlay() {
    $('body').append(`
      <div class="meta-overlay">
        <div class="meta-content">
          <div class="meta-header">
            <button class="btn-meta-overlay btn-meta-close">
              <i class="fas fa-times"></i>
            </button>
          </div>
          <div class="meta-body">

            <strong>${i18n.alwaysAvailable}:</strong>
            <br>

            ${this.content}
          </div>
        </div>
      </div>
    `);
    this.$MetaOverlay = $('body .meta-overlay');

    $('#header-outer #top .col.span_9.col_last').prepend(`
      <button class="btn-meta-overlay btn-meta-open">
        <i class="fas fa-phone"></i>
      </button>
    `);

    this.$MetaOverlayButtons = $('body .btn-meta-overlay');
    this.$MetaOverlayButtonOpen = $('body .btn-meta-overlay.btn-meta-open');
    this.$MetaOverlayButtonClose = $('body .btn-meta-overlay.btn-meta-close');

    this.$MetaOverlayButtonOpen.click(() => {
      this.$MetaOverlay.fadeIn(300);
    });

    this.$MetaOverlayButtonClose.click(() => {
      this.$MetaOverlay.fadeOut(300);
    });

    this.$MetaOverlayButtons.click(() => {
      this.$body.toggleClass('disable-scroll');
    });
  }

  tooltip() {
    this.$metaNavElement.addClass('has-dropdown');
    this.$metaNavElement.append('<i class="fas fa-caret-down"></i>');

    // turn this off to enable the original link tel again.
    this.$metaNavElement.click((e, wasTriggerd) => {
      if (!wasTriggerd) {
        e.preventDefault();
      }
    });
    this.$metaNavElement.on('dblclick', ((e) => {
      e.preventDefault();
      $(e.target).trigger('click', true);
    }));

    tippy(this.$metaNavElement[0], {
      content: this.content,
      allowHTML: true,
      interactive: true,
      placement: 'bottom-start',
      theme: 'facta',
      arrow: false,
      maxWidth: 'none',
      // trigger: 'click', // for styling the tippy content.
    });
  }
}
